import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const ProviderCustomReports =
  (APIData) => async (dispatch) => {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    try {
      const response = await axios({
        method: "post",
        data: APIData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          organisationid: storedData?.organisation_id,
        },
        url: `${actionType.environment_url}/api/provider/HandleCustomReports`,
      });
      return response.data;
    } catch (error) {
      return error.message;
    }
  };


  export const FetchAllProviderCustomReports = (apidata) => async (dispatch) => {
    /*** API Call Action ***/
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    try {
      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          organisationid: storedData?.organisation_id,
        },
        url: `${actionType.environment_url}/api/provider/GetAllCustomReports`,
        params: apidata, 
      });
  
      return response.data;  
    } catch (error) {
      console.error("Error in GetAllfavouriteReports:", error);  
      return { error: error.message };  
    }
  };